import { useSelector } from 'react-redux';
import { getListPageStore } from '../../selectors/conceptList';
import { isLoading } from '../../../common/selectors/meta';

export default function useIsListLoading() {
  const listStore = useSelector(getListPageStore);
  return isLoading(listStore);
}
